export default __webpack_public_path__ + "paddle_education22836f.svg";